<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 21 20"
    fill="none"
    style="enable-background:new 0 0 21 20;"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g id="icon_ball">
      <path
        id="Path"
        d="M14.7262 1.98141C13.4988 1.35393 12.1083 1 10.6351 1C5.66457 1 1.63513 5.02944 1.63513 10C1.63513 14.9706 5.66457 19 10.6351 19V19C15.6057 19 19.6351 14.9706 19.6351 10C19.6351 7.62169 18.7126 5.45885 17.2059 3.84978"
        stroke-linecap="round"
      />
      <g id="Group 2">
        <path
          id="Path 10"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.79761 9.55483L11.2201 7.04315L14.5559 9.55483L13.4223 13.8014H8.91486L7.79761 9.55483Z"
        />
        <path id="Path_2" d="M13.8691 1.66767L11.1378 3.92297L7.79756 1.66767" />
        <g id="Group">
          <path id="Path Copy" d="M19.8215 9.46483L17.3741 8.18171L18.1189 4.85713" />
          <path id="Path Copy 2" d="M14.1027 18.3026L14.9414 15.6695L17.6715 15.7098" />
          <path id="Path 11 Copy" d="M14.6057 9.62343L17.6239 8.10315" />
          <path id="Path 11 Copy 2" d="M13.2037 13.045L15.0312 15.8877" />
        </g>
        <g id="Group_2">
          <path id="Path Copy_2" d="M1.81838 10.4223L4.75029 8.20223L3.7884 4.30633" />
          <path id="Path Copy 2_2" d="M8.02153 18.3232L7.1829 15.6901L3.8196 15.6901" />
          <path id="Path 11 Copy_2" d="M8.00671 9.48615L4.50039 8.12366" />
          <path id="Path 11 Copy 2_2" d="M8.92053 13.0656L7.0931 15.9083" />
        </g>
        <path id="Path 11" d="M11.22 7.0432L11.1766 3.66406" />
      </g>
    </g>
  </svg>
</template>
<style scoped>
.icon-ball {
  stroke: currentColor;
  height: 24px;
  width: 24px;
  border-radius: initial;
  display: block;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-ball"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>